export function filterGWPValue(obj) {
  const result = {};
  const gwpKeys = [
    "co2GWPValue",
    "ch4NoGWPValue",
    "ch4FGWPValue",
    "n2oGWPValue",
    "hfcsGWPValue",
    "pfcsGWPValue",
    "sf6GWPValue",
    "nf3GWPValue",
  ];

  gwpKeys.forEach((key) => {
    const value = obj[key];

    if (
      value !== null &&
      value !== undefined &&
      value !== "" &&
      value !== "0.0" // ⭐ 只收非 0.0 的
    ) {
      result[key] = value;
    }
  });

  return result;
}
